import { Routes } from "@angular/router";
import { LendersListComponent } from "app/lenders/component/lenders-list/lenders-list.component";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { LendersAddComponent } from "./component/lenders-add/lenders-add.component";
import { LendersEditComponent } from "./component/lenders-edit/lenders-edit.component";
import { LendersCompanyComponent } from "./component/lenders-company/lenders-company.component";
import { LendersUserAuditModulesComponent } from "./component/lenders-user-audit-modules/lenders-user-audit-modules.component";
import { LenderAuditModuleViewComponent } from "./component/lender-audit-module-view/lender-audit-module-view.component";
import { LendersContactComponent } from "./component/lenders-contact/lenders-contact.component";

export const LENDERS_ROUTES: Routes = [
	{
		path: 'lenders',
		component: LayoutComponent,
		canActivate: [MsalGuard],
        children: [
            { path: '', component: LendersListComponent },
            { path: 'add', component: LendersAddComponent },
            { path: 'edit/:id', component: LendersEditComponent },
            { path: 'contact/:id', component: LendersContactComponent },
            { path: 'company/:id', component: LendersCompanyComponent },
            { path: 'user/:companyId/:userId', component: LendersUserAuditModulesComponent },
            { path: 'audit-module/:auditId/:moduleId', component: LenderAuditModuleViewComponent}
		]
	}
];
